// extracted by mini-css-extract-plugin
export var accent = "_bb-4";
export var add = "_bb-j";
export var addIcon = "_bb-k";
export var deleteIcon = "_bb-i";
export var disabled = "_bb-9";
export var ellipsis = "_bb-f";
export var error = "_bb-3";
export var form = "_bb-5";
export var hideFocus = "_bb-2";
export var icon = "_bb-7";
export var input = "_bb-e";
export var listItem = "_bb-h";
export var mediumHeight = "_bb-b";
export var noBorder = "_bb-8";
export var noRadius = "_bb-1";
export var shortHeight = "_bb-a";
export var tallHeight = "_bb-c";
export var textInput = "_bb-0";
export var vertical = "_bb-g";
export var veryTallHeight = "_bb-d";
export var widget = "_bb-6";